import { useColors } from "@/hooks/useColors";
import { getShadowMap } from "./getShadowMap";

export function ThemeLoader() {
	const colors = useColors();

	if (!colors) {
		return null;
	}

	const jsonVariables = {
		...colors,
		...getShadowMap(colors),
	};

	const cssVariables = Object.keys(jsonVariables)
		.map((key) => `--${key}: ${jsonVariables[key]}`)
		.join(";\n");

	return (
		<style>
			{`
        :root {
        ${cssVariables}
        }
      `}
		</style>
	);
}
